<main>
    <div class="admin_events_left">
        <div class="main_menu">
            <img (click)="go('/accueil/profil')" class="menus_avatar" src="{{imgUrl}}" alt="avatar">
            <p class="menus_name">
                <b>{{userData.username}}</b>
            </p>
            <div class="menus_tabs">
                <div class="menus_tab">
                    <img src="../../../assets/icons/JeuxAcadie_signature_horizontal 1.svg" alt="">
                </div>
                <div class="menus_tab menu_rapports" (click)="go('/admin')">
                    <p>Rapports</p>
                </div>
                <div class="menus_tab menu_evenements" (click)="go('/admin/evenements/liste')">
                    <p>Évènements</p>
                </div>
                <div class="menus_deconnexion" (click)="signOut()">
                    <p style="color: red; font-weight: 500;
                        position: absolute;bottom: 5%;width: 100%;text-align: center; cursor: pointer;">Se déconnecter</p>
                </div>
            </div>
        </div>
        <div class="mobile_menu">
            <img (click)="manageDropDown()" class="menus_avatar" src="../../../assets/icons/default_avatar.svg" alt="avatar">
            <div class="menus_tabs">
                <div class="menus_tab">
                    <img src="../../../assets/icons/JeuxAcadie_signature_horizontal 1.svg" alt="">
                </div>
                <div class="menus_tab menu_accueil" (click)="go('/admin')">
                    <p>Rapports</p>
                </div>
                <div class="menus_tab menu_evenements" (click)="go('/admin/evenements/liste')">
                    <p>Évènements</p>
                </div>
            </div>
            <div class="menu_dropdown">
                <hr>
                <p class="dropdown_profil" (click)="go('/accueil/profil')">
                    {{userData.username}} -&emsp;
                    <!--<b class="menus_stars">{{userData.medailles_count.toFixed(1)}}</b>
                    <span class="material-icons">grade</span>
                    <span class="material-icons chevron_right">chevron_right</span> -->
                </p>
                <p (click)="signOut()" style="color: red; font-weight: 500;
                        position: absolute;bottom: 5%;width: 100%;text-align: center; cursor: pointer;">Se déconnecter</p>
            </div>
        </div>
    </div>
    <div class="admin_events_right">
        <h4>Créer un évènement</h4>
        <div class="admin_right_ctn">
            <label for="admin_event_nom">
                <p>Nom de l'évènement: </p>
                <input [(ngModel)]="eventName" type="text" name="admin_event_nom" id="admin_event_nom">
            </label>
            <label for="admin_event_debut">
                <p>Début: </p>
                <input [(ngModel)]="dateDebut" type="date" name="admin_event_debut" id="admin_event_debut">
            </label>
            <label for="admin_event_fin">
                <p>Fin: </p>
                <input [(ngModel)]="dateFin" type="date" name="admin_event_fin" id="admin_event_fin">
            </label>
            <button (click)="createEvents()" class="admin_create_button">Créer l'évènement</button>
        </div>
        <div class="eventConfModal_ctn" style="display: none;">
            <div class="eventConfModal">
                <p>
                    Créer l'évènement "<b>{{eventName}}</b>"
                    Début: {{dateDebut}}  - Fin: {{dateFin}}
                </p>
                <div class="buttons_ctn">
                    <button (click)="create()">Oui</button>
                    <button (click)="manageEventModal()">Annuler</button>
                </div>
            </div>
        </div>
    </div>
</main>